import { Injectable } from '@angular/core';
import * as  OktaSignIn from '@okta/okta-signin-widget';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) { }

  authenticateUser(obj) {
    return this.http.post(environment.swpIamBaseUrl + `/Account/Token`, obj);
  }

  resetPassword(obj) {
    return this.http.post(environment.swpIamBaseUrl + `/Account/Token`, obj);
  }

  setNewPassword(obj) {
    return this.http.post(environment.swpIamBaseUrl + `/Account/ChangePassword`, obj);
  }
}
